import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {ProMessagingTemplateService} from '../pro-messaging-template.service';
import {EventEmitter, Injectable} from '@angular/core';
import {MessagingTemplateModel} from '../../api/models/messaging-template-model';
import {TemplateListRequest} from '../../api/models/template-list-request';

export interface TemplateSearchData {
  searchText?: string;
  type: '0' | '1' | '2';
}

@Injectable()
export class SelectTemplateV2Datasource implements DataSource<MessagingTemplateModel | undefined> {
  private _length = 0;
  private _pageSize = 100;
  private _currentPage = 0;
  private _cachedData = Array.from<MessagingTemplateModel>({length: 0});
  private _fetchedPages = new Set<number>();
  private _dataStream = new BehaviorSubject<(MessagingTemplateModel | undefined)[]>(this._cachedData);
  private _subscription = new Subscription();
  private _searchSubscription = new Subscription();
  private _searchData: TemplateSearchData = {type: '0'};
  public searchTextEmitter = new EventEmitter<TemplateSearchData>();

  constructor(public messagingTemplateService: ProMessagingTemplateService) {

  }

  connect(collectionViewer: CollectionViewer): Observable<(MessagingTemplateModel | undefined)[]> {
    this._subscription = collectionViewer.viewChange.subscribe(async (range) => {
      const startPage = this._getPageForIndex(range.start);
      const endPage = this._getPageForIndex(range.end - 1);
      for (let i = startPage; i <= endPage; i++) {
        await this._fetchPage(i);
      }
    });

    this._searchSubscription = this.searchTextEmitter.subscribe(async (searchData) => {
      this._searchData = searchData;
      this._length = 0;
      await this._refreshData(0, true);
    });

    return this._dataStream;
  }

  disconnect(): void {
    this._subscription?.unsubscribe();
    this._searchSubscription?.unsubscribe();
  }

  private _getPageForIndex(index: number): number {
    this._currentPage = Math.floor(index / this._pageSize);
    return this._currentPage;
  }

  private async _refreshData(page: number, resetPages: boolean): Promise<void> {
    if (resetPages) {
      this._fetchedPages = new Set<number>();
    }

    this._cachedData = Array.from<MessagingTemplateModel>({length: 0});
    this._dataStream.next(this._cachedData);

    await this._fetchPage(page);
  }

  private async _fetchPage(page: number) {
    console.log('_fetchPage ---- Datasource ' + page);
    if (this._fetchedPages.has(page)) {
      return;
    }
    this._fetchedPages.add(page);

    const request: TemplateListRequest = {
      searchText: this._searchData.searchText,
      type: Number(this._searchData.type),
      category: 0,
      limit: this._pageSize,
      skip: this._pageSize * page,
      sort: [{direction: 'DESC', field: 'order'}, {direction: 'ASC', field: 'name'}],
      user: undefined,
    };

    const data = await this.messagingTemplateService.getTemplateListResponse(request);

    if (this._length === 0) {
      this._length = data.total;
      this._cachedData = Array.from<MessagingTemplateModel>({length: this._length});
    }

    this._cachedData.splice(request.skip, data.data.length, ...data.data);

    this._dataStream.next(this._cachedData);
  }
}
